// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/trip/schedule.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_annotations } from "../core/annotations_pb";
import { file_proto_model_core_date } from "../core/date_pb";
import { file_proto_model_trip_event } from "./event_pb";
import { file_proto_model_core_model_path } from "../core/model_path_pb";

/**
 * Describes the file proto/model/trip/schedule.proto.
 */
export const file_proto_model_trip_schedule = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_field_mask, file_google_protobuf_timestamp, file_proto_model_core_annotations, file_proto_model_core_date, file_proto_model_trip_event, file_proto_model_core_model_path]);

/**
 * Describes the message carmen.Schedule.
 * Use `create(ScheduleSchema)` to create a new message.
 */
export const ScheduleSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_schedule, 0);

/**
 * Describes the message carmen.ScheduleDisplay.
 * Use `create(ScheduleDisplaySchema)` to create a new message.
 */
export const ScheduleDisplaySchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_schedule, 1);

/**
 * Describes the message carmen.Stay.
 * Use `create(StaySchema)` to create a new message.
 */
export const StaySchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_schedule, 2);

/**
 * Describes the message carmen.Day.
 * Use `create(DaySchema)` to create a new message.
 */
export const DaySchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_schedule, 3);

/**
 * Describes the message carmen.ScheduleContentCreation.
 * Use `create(ScheduleContentCreationSchema)` to create a new message.
 */
export const ScheduleContentCreationSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_schedule, 4);

/**
 * Describes the message carmen.ScheduleContentFieldUpdate.
 * Use `create(ScheduleContentFieldUpdateSchema)` to create a new message.
 */
export const ScheduleContentFieldUpdateSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_schedule, 5);

/**
 * Describes the message carmen.ScheduleContentUpdate.
 * Use `create(ScheduleContentUpdateSchema)` to create a new message.
 */
export const ScheduleContentUpdateSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_schedule, 6);

/**
 * Describes the message carmen.SchedulingPreferences.
 * Use `create(SchedulingPreferencesSchema)` to create a new message.
 */
export const SchedulingPreferencesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_schedule, 7);

/**
 * Describes the message carmen.SchedulingMetadata.
 * Use `create(SchedulingMetadataSchema)` to create a new message.
 */
export const SchedulingMetadataSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_schedule, 8);

/**
 * Describes the message carmen.SchedulingResult.
 * Use `create(SchedulingResultSchema)` to create a new message.
 */
export const SchedulingResultSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_schedule, 9);

/**
 * Describes the enum carmen.SchedulingStatus.
 */
export const SchedulingStatusSchema = /*@__PURE__*/
  enumDesc(file_proto_model_trip_schedule, 0);

/**
 * @generated from enum carmen.SchedulingStatus
 */
export const SchedulingStatus = /*@__PURE__*/
  tsEnum(SchedulingStatusSchema);

